/* eslint-disable react/prop-types */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/no-unused-state */

import React, { Component } from "react";

import styles from "./ContactUsHeroSection.module.css";
import Link from "../../components/LinkWithCountry/LinkWithCountry";
import endpoints from "../../shared/constants/endpoints";

const heroSectionImage = require("./imgs/hero-section-image.jpg")

class ContactUsHeroSection extends Component {
  componentDidMount() {}

  render() {
    return (
      <div data-part="contact-hero" className={`${styles.heroSection} w-full h-[508px] lg:h-[390px]`}>
        <div data-part="contact-hero-inner" className="flex flex-col lg:flex-row items-center justify-between mx-auto max-w-screen-desktop h-full px-4 lg:px-0 py-8 lg:py-12">
          {/* Hero Text Section */}
          <div data-part="contact-hero-copy" className={`${styles.heroText} flex flex-col gap-3 lg:gap-4 w-full lg:w-auto lg:flex-1 items-start`}>
            <h1 className="font-congenialBold font-black text-[32px] md:text-[44px] leading-8 md:leading-10 tracking-[-1px] text-light">
              Contact Us
            </h1>
            <p className="font-montserratMedium font-[500] text-base md:text-lg leading-5 md:leading-[22px] tracking-[-0.1px] text-light ">
              We&apos;re here to help!
            </p>
            <p className="font-montserratMedium font-[500] text-base md:text-lg leading-5 md:leading-[22px] tracking-[-0.1px] text-light mb-4 lg:mb-6">
              For general inquiries about bakery locations, hours or menus,
              please visit your bakery&apos;s page.
            </p>
            {/* Find a Bakery Button */}
            <Link to={endpoints.locations}>
              <button type="button" className="bg-button w-[144px] h-[44px] text-white font-montserratMedium font-[500] text-base rounded-[44px]">
                Find a Bakery
              </button>
            </Link>
          </div>
          
          {/* Hero Image Section */}
          <div data-part="contact-hero-photo" className={`${styles.heroImage} w-full lg:w-auto lg:flex-1 flex justify-center lg:justify-end mt-6 lg:mt-0`}>
            <div className="w-full max-w-[400px] lg:max-w-[510px] h-[250px] md:h-[300px] lg:h-[342px] rounded-lg overflow-hidden shadow-lg">
              <img 
                src={heroSectionImage}
                alt=""
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ContactUsHeroSection;
